import { IType } from './common';
import { IMappedType } from './mapped-type.interface';
import {
  inheritPropertyInitializers,
  inheritTransformationMetadata,
  inheritValidationMetadata,
} from './type-helpers.utils';
import { TRemoveFieldsWithType } from './types/remove-fields-with-type.type';

export function PickType<T, K extends keyof T>(
  classRef: IType<T>,
  keys: readonly K[],
) {
  const isInheritedPredicate = (propertyKey: string) =>
    keys.includes(propertyKey as K);

  abstract class PickClassType {
    constructor() {
      inheritPropertyInitializers(this, classRef, isInheritedPredicate);
    }
  }
  inheritValidationMetadata(classRef, PickClassType, isInheritedPredicate);
  inheritTransformationMetadata(classRef, PickClassType, isInheritedPredicate);

  return PickClassType as IMappedType<
    TRemoveFieldsWithType<Pick<T, (typeof keys)[number]>, unknown>
  >;
}
